<template>
  <div class="form-editor-wrapper adapt-wrapper">
    <div class="editor-title">{{ headerLable }}</div>
    <el-divider></el-divider>
    <div class="form-header">
      <slot name="formHeader"></slot>
    </div>
    <el-form
      ref="form"
      :label-position="labelPosition"
      :inline="inlineForm"
      :style="{ width: formWidth }"
      :label-width="labelWidth"
      :model="model"
      :disabled="disabled"
      :rules="rules">
      <template v-for="(item, index) in formLines">
        <el-form-item
          v-if="!item.hidden"
          :key="index"
          :label="item.label"
          :prop="item.name"
        >
          <slot :name="item.slotName" :line="item">
            <el-input v-model="model[item.name]" :placeholder="item.placeholder" :disabled="item.disabled"></el-input>
          </slot>
        </el-form-item>
      </template>
    </el-form>
    <slot name="formBottom"></slot>
    <div class="bottom-btn-group">
      <slot name="btnGroups">
        <el-button class="cancel-btn grey-btn" @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
        <el-button class="save-btn blue-btn" @click="handleSave">{{ $t('common.btn.save') }}</el-button>
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    formWidth: {
      type: String,
      default: '350px'
    },
    labelWidth: {
      type: String,
      default: 'auto'
    },
    headerLable: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    },
    formLines: {
      type: Array,
      required: true
    },
    inlineForm: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: 'left'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    form () {
      const form = {
        ...this.$refs.form,
        validate: (callBack) => {
          if (!callBack) {
            return this.$refs.form.validate()
          } else {
            this.$refs.form.validate((isSuccess, failObject) => {
              if (!isSuccess) {
                this.$nextTick(() => {
                  document.querySelector('.el-form-item.is-error').scrollIntoView({ block: 'center', behavior: 'smooth' })
                })
              }
              callBack(isSuccess, failObject)
            })
          }
        }
      }
      return form
    }
  },
  created () {

  },
  methods: {
    handleCancel () {
      this.$emit('cancel')
    },
    handleSave () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-editor-wrapper {
  .editor-title {
    font-size: 13px;
    color: #777;
  }

  .el-divider {
    margin-top: 8px;
  }

  .el-form {
    margin: auto;

    .el-form-item::v-deep {
      .el-select {
        width: 100%;
      }

      .el-form-item__label {
        color: #555;
      }

      .el-input__inner {
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .bottom-btn-group {
    padding: 20px 40px 0;
    display: flex;

    .el-button {
      padding: 8px 20px;

      &:last-child {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }
}
</style>
